var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "lang-switcher",
    },
    [
      _c(
        "button",
        {
          staticClass: "lang-trigger",
          on: {
            click: function ($event) {
              _vm.isOpen = !_vm.isOpen
            },
          },
        },
        [
          _c("img", {
            staticClass: "lang-flag",
            attrs: {
              src: `https://flagcdn.com/w20/${_vm.getLocalFlagString()}.png`,
              alt: "flag",
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$i18n.locale.toUpperCase()))]),
          _c(
            "span",
            { staticClass: "lang-arrow", class: { "is-open": _vm.isOpen } },
            [_vm._v("▾")]
          ),
        ]
      ),
      _vm.isOpen
        ? _c("div", { staticClass: "lang-dropdown" }, [
            _c(
              "button",
              {
                staticClass: "lang-option",
                on: {
                  click: function ($event) {
                    return _vm.select("en")
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: "https://flagcdn.com/w20/us.png", alt: "" },
                }),
                _vm._v(" English "),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "lang-option",
                on: {
                  click: function ($event) {
                    return _vm.select("fr")
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: "https://flagcdn.com/w20/fr.png", alt: "" },
                }),
                _vm._v(" Français "),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "lang-option",
                on: {
                  click: function ($event) {
                    return _vm.select("ru")
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: "https://flagcdn.com/w20/ru.png", alt: "" },
                }),
                _vm._v(" Pусский "),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "lang-option",
                on: {
                  click: function ($event) {
                    return _vm.select("zh")
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: "https://flagcdn.com/w20/cn.png", alt: "" },
                }),
                _vm._v(" 普通话 "),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "lang-option",
                on: {
                  click: function ($event) {
                    return _vm.select("kr")
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: "https://flagcdn.com/w20/kr.png", alt: "" },
                }),
                _vm._v(" 한국어 "),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }